import { values } from './enums'

const _enum = {
  None: 0,
  ReadOnly: 1,
  Edit: 2
}

export const permissionTypes = {
  enumName: 'PermissionTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/permissionTypes.js